import React from 'react';
import { Link } from 'react-router-dom';

const servicesList = [
  {
    icon: 'fas fa-lightbulb',
    title: 'LED Sign Boards',
    desc: 'Custom illuminated LED letter signs crafted from stainless steel and acrylic. Available in channel letters, back-lit, front-lit and halo-lit configurations. Energy efficient, weather-resistant and built for decades of use.',
    features: ['Channel Letters', 'Backlit Panels', 'Rim Lit Signs', 'Logo Signs'],
    img: 'https://images.unsplash.com/photo-1565043589221-1a6fd9ae45c7?w=700&q=80',
  },
  {
    icon: 'fas fa-layer-group',
    title: 'ACP Signage',
    desc: 'Premium aluminium composite panel signs with computerised cut letters and LED lit logos. Extensive colour range from basic to metallic, wooden and marble textures. The perfect upgrade from basic sign boards.',
    features: ['Single Skin ACP', 'Double Skin ACP', 'Custom Cutouts', 'UV Printing'],
    img: 'https://images.unsplash.com/photo-1611095564985-4b6e372c3bfb?w=700&q=80',
  },
  {
    icon: 'fas fa-map-signs',
    title: 'Wayfinding & Totems',
    desc: 'Complete directional signage systems tailored to each environment. From hospitals and campuses to office parks and retail complexes — we ensure visitors always know where to go.',
    features: ['Directional Signs', 'Totem Pillars', 'Floor Maps', 'Info Kiosks'],
    img: 'https://images.unsplash.com/photo-1497366216548-37526070297c?w=700&q=80',
  },
  {
    icon: 'fas fa-broadcast-tower',
    title: 'Hoardings & Billboards',
    desc: 'Large-format outdoor advertising structures — unipoles, flex hoardings and backlit billboards placed on prime locations across major Indian cities. Maximum reach, maximum impact.',
    features: ['Unipole Structures', 'Gantry Boards', 'Backlit Hoardings', 'Transit Advertising'],
    img: 'https://images.unsplash.com/photo-1580587771525-78b9dba3b914?w=700&q=80',
  },
  {
    icon: 'fas fa-car',
    title: 'Vehicle Branding',
    desc: 'Transform your fleet into moving billboards. Full vehicle wraps, partial decals and window graphics using premium cast vinyl films. Durable and weather-resistant for years of outdoor use.',
    features: ['Full Car Wraps', 'Fleet Branding', 'Window Graphics', 'Bus Branding'],
    img: 'https://images.unsplash.com/photo-1593508512255-86ab42a8e620?w=700&q=80',
  },
  {
    icon: 'fas fa-desktop',
    title: 'Digital Displays',
    desc: 'High-brightness LED video walls and digital signage screens for indoor and outdoor use. From digital menu boards in restaurants to large outdoor LED billboards — we install and maintain them all.',
    features: ['LED Video Walls', 'Digital Menu Boards', 'Kiosk Displays', 'Outdoor LED Screens'],
    img: 'https://images.unsplash.com/photo-1579873948173-b236b5fc5c17?w=700&q=80',
  },
];

function Services() {
  return (
    <>
      <div className="page-hero">
        <div className="container">
          <div className="breadcrumb">
            <Link to="/">Home</Link>
            <i className="fas fa-chevron-right" />
            <span>Services</span>
          </div>
          <h1 className="page-hero-title">
            Our <span>Services</span>
          </h1>
          <p className="section-desc light" style={{ marginTop: 16 }}>
            Comprehensive signage and advertising solutions tailored for every business need.
          </p>
        </div>
      </div>

      <section style={{ padding: '80px 0', background: '#fff' }}>
        <div className="container">
          <div style={{ display: 'flex', flexDirection: 'column', gap: 80 }}>
            {servicesList.map((svc, i) => (
              <div
                key={i}
                style={{
                  display: 'grid',
                  gridTemplateColumns: '1fr 1fr',
                  gap: 60,
                  alignItems: 'center',
                  direction: i % 2 === 1 ? 'rtl' : 'ltr',
                }}
                className="service-detail-row"
              >
                <div style={{ direction: 'ltr' }}>
                  <div className="service-icon" style={{ marginBottom: 20 }}>
                    <i className={svc.icon} />
                  </div>
                  <span className="section-label">{`0${i + 1}`}</span>
                  <h2 className="section-title" style={{ fontSize: '2.2rem' }}>{svc.title}</h2>
                  <p className="section-desc">{svc.desc}</p>
                  <div style={{ display: 'flex', flexWrap: 'wrap', gap: 10, marginTop: 24 }}>
                    {svc.features.map(f => (
                      <span
                        key={f}
                        style={{
                          background: 'rgba(212,160,23,0.1)',
                          border: '1px solid rgba(212,160,23,0.3)',
                          color: '#B8860B',
                          padding: '6px 14px',
                          borderRadius: 4,
                          fontSize: '0.8rem',
                          fontFamily: 'var(--font-condensed)',
                          fontWeight: 700,
                          letterSpacing: '0.1em',
                          textTransform: 'uppercase',
                        }}
                      >
                        {f}
                      </span>
                    ))}
                  </div>
                  <Link to="/contact" className="btn btn-primary" style={{ marginTop: 28 }}>
                    Request Quote <i className="fas fa-arrow-right" />
                  </Link>
                </div>
                <div style={{ direction: 'ltr' }}>
                  <img
                    src={svc.img}
                    alt={svc.title}
                    style={{ width: '100%', aspectRatio: '4/3', objectFit: 'cover', borderRadius: 12 }}
                    loading="lazy"
                  />
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="cta-section">
        <div className="container">
          <div className="cta-inner">
            <div>
              <h2 className="cta-title">
                Need a Custom <span>Signage Solution?</span>
              </h2>
              <p className="cta-desc">Our experts will design and build exactly what your brand needs.</p>
            </div>
            <div className="cta-buttons">
              <Link to="/contact" className="btn btn-primary">
                Get In Touch <i className="fas fa-arrow-right" />
              </Link>
            </div>
          </div>
        </div>
      </section>

      <style>{`
        @media (max-width: 768px) {
          .service-detail-row {
            grid-template-columns: 1fr !important;
            direction: ltr !important;
          }
        }
      `}</style>
    </>
  );
}

export default Services;
